import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api.js';
import { canAccessIa, type AcademyRecursos } from '@shared/entitlements.js';

/** O `GET /auth/me` — mesma chave de cache das outras telas que já o leem. */
export type Me = {
  id: string;
  name: string;
  email: string;
  role: string;
  recursos?: AcademyRecursos;
  suporte?: unknown;
  /** Decidido pelo cadastro no HAOps, não pelo plano. */
  conselheiro?: { conselheiro: boolean; empresa: boolean };
};

export function useMe(enabled = true) {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => (await api.get<Me>('/auth/me')).data,
    enabled,
  });
}

const EQUIPE = ['ADMIN', 'SUPER_ADMIN'];

/**
 * Itens do app que dependem do plano ou do papel. O que não está aqui é de
 * todo mundo. A API já recusa o que a pessoa não tem; o menu só para de
 * oferecer o que vai dar em recusa.
 */
export type AreaRestrita = 'conselheiro' | 'formacao' | 'ia' | 'trilhas';

export function podeVer(me: Me | undefined, area: AreaRestrita): boolean {
  if (!me) return false;
  if (EQUIPE.includes(me.role)) return true;
  const r = me.recursos ?? {};
  switch (area) {
    case 'conselheiro':
      return !!(me.conselheiro?.conselheiro || me.conselheiro?.empresa || r.conselheiro);
    case 'formacao':
      // A Biblioteca do método é do conselheiro (em formação ou certificado), não da empresa.
      return !!me.conselheiro?.conselheiro;
    case 'ia':
      return canAccessIa(r);
    case 'trilhas':
      return (r.trilhas?.length ?? 0) > 0;
  }
}
